import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TVCPage from "../pages/services/tvc/page";
import MusicMVPage from "../pages/services/music-mv/page";
import DigitalHumanPage from "../pages/services/digital-human/page";
import ExhibitionPage from "../pages/services/exhibition/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services/tvc",
    element: <TVCPage />,
  },
  {
    path: "/services/music-mv",
    element: <MusicMVPage />,
  },
  {
    path: "/services/digital-human",
    element: <DigitalHumanPage />,
  },
  {
    path: "/services/exhibition",
    element: <ExhibitionPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
